import { render, staticRenderFns } from "./cluster.events.item.vue?vue&type=template&id=230b9b8c&"
import script from "./cluster.events.item.vue?vue&type=script&lang=js&"
export * from "./cluster.events.item.vue?vue&type=script&lang=js&"
import style0 from "./cluster.events.item.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports